declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export function reportSignupConversion(sendTo: string) {
  const adsId = sendTo.split("/")[0];
  const dataLayer = (window.dataLayer ??= []);
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    dataLayer.push(arguments); // Note: this must be `arguments`, not ...args because reasons
  };

  window.gtag("js", new Date());
  window.gtag("config", adsId);
  window.gtag("event", "conversion", { send_to: sendTo });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(adsId)}`;
  document.head.appendChild(script);
}
